"use client";
import { Box } from "../../core/Box/Box.mjs";
import { useModalBaseContext } from "./ModalBase.context.mjs";
import ModalBase_module_default from "./ModalBase.module.mjs";
import { useModalTitle } from "./use-modal-title-id.mjs";
import cx from "clsx";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/ModalBase/ModalBaseTitle.tsx
function ModalBaseTitle({ className, ...others }) {
	const id = useModalTitle();
	const ctx = useModalBaseContext();
	return /* @__PURE__ */ jsx(Box, {
		component: "h2",
		className: cx({ [ModalBase_module_default.title]: !ctx.unstyled }, className),
		id,
		...others
	});
}
ModalBaseTitle.displayName = "@mantine/core/ModalBaseTitle";
//#endregion
export { ModalBaseTitle };

//# sourceMappingURL=ModalBaseTitle.mjs.map